'use strict';
/* ==========================================================================
   levels/title.js — the title screen of "The Big Drop II", in The Big Drop's collage look dressed as a case file:
   a manila folder open on the desk; paper-clipped to it, a photo of the s3 run with the cart stopped at the brake run
   and the heat view on (HeatKit.coaster: the brake run's colour is the model's temperature, Thermo.brakeRun, on the
   station scale, labelled as a model); a red CASE FILE stamp; the ransom title, the hand-written subtitle; Max and
   Dr. Voss rise in at the two lower corners. Play (Enter) → the map. Pure in time: everything is keyed to T and the
   scene's entry time. On a phone held upright the controls move to the portrait dock (Dock.title) and the stage keeps
   only the art. Levels.title.loading() draws the "cutting paper…" page while the boot tier loads (no textures yet).
   ========================================================================== */
(function () {
  const PLAY = { x: 1470, y: 640 };
  const PHOTO = { x: 240, y: 330, w: 820, h: 440 };            // the photo's inner picture (logical px)
  const DESK = '#5d4330', MANILA = '#e8d3a3', MANILA_DK = '#d4b97f';

  function folder() {
    g.fillStyle = paperTile(DESK, 4, 'tex_kraft'); g.fillRect(0, 0, Game.W, Game.H);
    paperRect(1530, 60, 420, 80, MANILA_DK, { seed: 902, depth: 0.7, boil: false });
    g.fillStyle = paperTile(MANILA_DK, 6); g.fillRect(40, 80, 1840, 960);
    g.fillStyle = 'rgba(40,24,10,0.25)'; g.fillRect(54, 100, 1826, 6);
    g.fillStyle = paperTile(MANILA, 5); g.fillRect(52, 92, 1816, 940);
    g.save(); g.strokeStyle = 'rgba(90,64,30,0.35)'; g.lineWidth = 2; g.strokeRect(52, 92, 1816, 940); g.restore();
    HeatKit.text('CASE FILE · HEAT', 1530, 46, 28, { align: 'center', color: '#6b4a2f' });
  }

  /* the photo: the coaster at rest at the brake run, heat view on (the model's numbers), clipped + labelled */
  function photo(t0) {
    const s = pop(T, t0 + 0.15, 0.4, 1.6);
    if (s <= 0) return;
    const cx = PHOTO.x + PHOTO.w / 2, cy = PHOTO.y + PHOTO.h / 2;
    g.save(); g.translate(cx, cy); g.rotate(-0.025); g.scale(s, s); g.translate(-cx, -cy);
    paperRect(cx, cy + 14, PHOTO.w + 44, PHOTO.h + 72, '#fffdf7', { seed: 1201, depth: 1.6, boil: false });
    const R = Tracks.get('s3');
    HeatKit.coaster(PHOTO, { t: R.sim.tSettle != null ? R.sim.tSettle : 16, heat: true, from: 66, to: 152 });
    HeatKit.text('Heat view: a computer model of the temperatures, not a camera', cx, PHOTO.y + PHOTO.h + 30, 22, { align: 'center', color: '#5b4a3a' });
    HeatKit.drawPart('clip', PHOTO.x + 60, PHOTO.y - 34, -0.12, 1.2);
    g.restore();
  }

  class Title extends Scene {
    enter() { this.started = false; HeatKit.load(); }
    go() {
      if (this.started) return;
      this.started = true;
      Audio.unlock();
      if (Game.MUSIC) Audio.music(Game.MUSIC, { gain: 0.3 });
      Game.replace(new Levels.map());
    }
    keyDown(k) { if (k === 'Enter' || k === ' ') this.go(); }

    draw() {
      UI.allLessons();                       // "← All lessons" (a tab; in the portrait dock a button in its bar)
      const t = this.t, t0 = this.enteredAt, L = Game.lesson || {};
      folder();
      photo(t0);
      // the stamp slams onto the photo's corner
      const st = t0 + 1.0, ss = pop(T, st, 0.18, 1.2) * (1 + 1.3 * (1 - P(T, st, st + 0.12)));
      if (T >= st && !this.stamped) { this.stamped = true; Audio.play('stamp_case', { gain: 0.7 }); }
      if (ss > 0) UI.stamp('CASE FILE', PHOTO.x + PHOTO.w - 150, PHOTO.y + 80, { rot: 0.14, s: ss * 0.8, color: '#c0392b' });
      // the title
      ransom((L.title || 'The Big Drop II').toUpperCase(), 960, 190, 96, t0 + 0.35, { seed: 211 });
      hand('where did the heat go?', 1470, 420, 70, t0 + 0.9, { dur: 0.45, color: '#c0392b', rot: -0.03 });
      ink([[1230, 470], [1470, 462], [1710, 472]], { w: 6, seed: 19, prog: P(T, t0 + 1.3, t0 + 1.55), color: PAL.mustard });
      // the cast
      const rise = n => E.outBack(P(T, t0 + n, t0 + n + 0.5), 1.4);
      Puppet.draw('max', 150, 1080 + (1 - rise(0.7)) * 500, 470, { facing: 1, t: T, pose: 'point' });
      Puppet.draw('voss', 1760, 1080 + (1 - rise(0.9)) * 500, 520, { facing: -1, t: T });

      // portrait phone: the title's controls are in the dock (core/dock.js Dock.title); the stage keeps the art
      if (UI.docked()) { Dock.title({ onStart: () => this.go(), onContinue: () => this.go() }); return; }
      if (t > 1.4 && UI.button('play', 'Play', PLAY.x, PLAY.y, { w: 420, h: 136, color: PAL.red, font: "'Luckiest Guy'", size: 70, rot: -0.02 })) this.go();
      if (t > 2.4) hand(UI.hint('(or press Enter)', 'tap Play to open the case'), PLAY.x, PLAY.y + 112 + (UI.tap(136) - 136) / 2, UI.text(40), t0 + 2.4, { color: '#5b4a3a', seed: 61 });
    }
  }
  Title.PLAY = PLAY;                         // tools/integration.js clicks it
  Title.PHOTO = PHOTO;

  /* the loading page (no textures yet): plain paper, ink scissors snipping along a dashed line (as The Big Drop) */
  Title.loading = function () {
    g.fillStyle = MANILA; g.fillRect(0, 0, Game.W, Game.H);
    const cx = 960, cy = 470, x0 = 620, x1 = 1300;
    const prog = (T * 0.35) % 1, sx = lerp(x0, x1, prog);
    for (let x = x0; x < x1; x += 34) ink([[x, cy + 60], [x + 18, cy + 60]], { w: 4, seed: x, alpha: x < sx ? 0.25 : 0.8, passes: 1, step: 20 });
    const open = 0.28 + Math.sin(T * 12) * 0.22;
    g.save(); g.translate(sx, cy + 60);
    [-1, 1].forEach(side => {
      g.save(); g.rotate(side * open);
      ink([[0, 0], [120, -6 * side], [150, 0]], { w: 7, seed: 70 + side, color: PAL.ink, step: 12 });
      ink([[0, 0], [-60, 18 * side]], { w: 7, seed: 72 + side, step: 12 });
      inkCircle(-86, 28 * side, 26, { w: 6, seed: 74 + side, color: side > 0 ? PAL.red : PAL.navy });
      g.restore();
    });
    g.restore();
    hand('opening the case file…', cx, cy + 190, 84, 0, { dur: 0.01, seed: 5 });
  };

  Levels.title = Title;
})();
